import { AccountChildIcon } from './AccountChildIcon';

/**
 * author: Google
 * id 431A5DA2-1B7E-4B86-8EAE-BEE1099048A1
 * name account-child
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-child.svg
 * tags
 * - Account / User 
 */
export const PersonChildIcon = AccountChildIcon;
export default PersonChildIcon